<template>
  <div id="app">
    <!--顶部nav-->
    <!-- <div class="topCommon">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="" />
      </div>
    </div> -->
    <div v-if="nav">
      <div class="topBox" style="height: auto">
        <!-- <div class="search">
          <div>
            <el-input
              v-model="input"
              placeholder="请输入内容"
              class="searchInput"
            ></el-input>
            <el-button type="primary" class="searchType" @click="searchFun(1)"
              >按正文<span style="color: #ffe200; padding-left: 5px"
                >全面搜索</span
              ></el-button
            >
            <el-button type="primary" class="searchType" @click="searchFun(2)"
              >按标题<span style="color: #ffe200; padding-left: 5px"
                >极速搜索</span
              ></el-button
            >
            <el-button type="primary" class="searchType" @click="searchFun(3)"
              >按文号<span style="color: #ffe200; padding-left: 5px"
                >特定搜索</span
              ></el-button
            >
          </div>
        </div> -->
        <div class="typeBox">
          <img
            src="@/assets/images/zsy_icon_01.png"
            alt=""
            style="transform: none; cursor: auto"
          />
          <img
            src="@/assets/images/0445_03.jpg"
            alt=""
            @click="jump('index')"
          />
          <img src="@/assets/images/0445_05.jpg" alt="" @click="jump('szyw')" />
          <img src="@/assets/images/0445_09.jpg" alt="" @click="jump('gfjj')" />
          <img src="@/assets/images/0445_11.jpg" alt="" @click="jump('hyss')" />
          <img
            src="@/assets/images/0445_13.jpg"
            alt=""
            @click="jump('qyqcss')"
          />
          <img src="@/assets/images/0445_15.jpg" alt="" @click="jump('sgcy')" />
          <img src="@/assets/images/0445_17.jpg" alt="" @click="jump('kjcy')" />
          <img src="@/assets/images/0445_19.jpg" alt="" @click="jump('ssyh')" />
          <img
            src="@/assets/images/0445_07.jpg"
            alt=""
            @click="jump('jckss')"
          />
        </div>
      </div>
      <div style="width: 100%; background: #f5f5f5; padding: 20px 0 0 0">
        <div class="banner">
          <img src="@/assets/images/00_banner_1200px_120px.png" alt="" />
          <!-- <img src="@/assets/images/btn.png" alt="" @click="drawer = true" style="cursor: pointer;"> -->
        </div>
      </div>
    </div>
    <div class="midCommon">
      <div style="padding-bottom: 50px">
        <div class="contentBox">
          <div class="title" v-html="data.title"></div>
          <div class="more" v-if="data.modelId !== 'shi_wu'">
            <div
              class="time"
              v-if="data.modelId == 'xggd' && data.attribute.source"
            >
              来源:{{ data.attribute.source }}
            </div>
            <div class="time" v-if="data.modelId == 'xggd' && data.author">
              作者:{{ data.author }}
            </div>
            <div
              class="time"
              v-if="
                (data.modelId == 'dayi' || data.modelId == 'jiedu') &&
                data.author
              "
            >
              发文单位:{{ data.author }}
            </div>
            <div
              class="time"
              v-if="
                data.author &&
                data.modelId != 'xggd' &&
                data.modelId != 'dayi' &&
                data.modelId != 'jiedu'
              "
            >
              发文机关:<span v-html="data.author"></span>
            </div>
            <div class="time" v-if="data.editor">
              发文文号:<span v-html="data.editor"></span>
            </div>
            <div class="time" v-if="data.publishDate">
              发文日期:{{ data.publishDate | publishDate }}
            </div>

            <!-- <div class="time" v-if="data.attribute&&data.attribute.state">文件效力:{{data.attribute.state | typeFil(that)}}</div> -->
            <div class="time" v-if="data.xlfwName">
              文件效力:{{ data.xlfwName }}
            </div>
          </div>
          <div class="more" v-if="data.modelId == 'shi_wu'">
            <div class="time" v-if="data.attribute && data.attribute.fwdw">
              发文机关:<span v-html="data.attribute.fwdw"></span>
            </div>
            <div class="time" v-if="data.editor">
              发文文号:<span v-html="data.editor"></span>
            </div>
            <div class="time" v-if="data.publishDate">
              发文日期:{{ data.publishDate | publishDate }}
            </div>
            <div class="time" v-if="data.attribute && data.attribute.state">
              文件效力:{{ data.attribute.state | typeFil }}
            </div>
            <div class="time" v-if="data.attribute && data.attribute.source">
              来源:<span v-html="data.attribute.source"></span>
            </div>
            <div class="time" v-if="data.author">
              作者:<span v-html="data.author"></span>
            </div>
          </div>
          <div class="text" id="text" v-html="imgUrl(data.content_formatted)"></div>
          <div
            style="
              padding-top: 16px;
              border-top: 2px solid #d8d8d8;
              font-size: 18px;
              color: #3d3d3d;
            "
            v-if="listId == 4023"
          >
            提示：本文章仅供学习参考，如有侵权请联系删除。
          </div>
          <div
            style="
              padding-top: 16px;
              border-top: 2px solid #d8d8d8;
              font-size: 18px;
              color: #3d3d3d;
            "
            v-if="listId == 4027"
          >
            提示：该答复仅供参考。
          </div>
          <!-- <div
            class="vipText"
            v-if="
              $store.state.user.vipInfo == null ||
              $store.state.user.vipInfo.isVip != 1
            "
          >
            ------------以下内容省略若干行,请<span @click="vipFun">续费VIP</span
            >后查看------------
          </div>
          <div
            v-if="
              $store.state.user.vipInfo != null &&
              $store.state.user.vipInfo.isVip == 1
            "
          > -->
            <div
              class="typeBoxs"
              v-if="data.FilesInfo && data.FilesInfo.length > 0"
            >
              <div class="accessory">
                <span style="margin-left: 14px"> 附件:</span>
              </div>
              <div class="titleBox" v-for="item in data.FilesInfo">
                <span
                  class="title"
                  style="cursor: pointer"
                  @click="download(item, 1)"
                  >{{ item.title }}</span
                >
                <span
                  @click="download(item, 2)"
                  class="btn"
                  style="cursor: pointer"
                  v-if="item.contentFilePath"
                  >下载</span
                >
                <span
                  @click="download(item, 1)"
                  class="btn"
                  style="cursor: pointer"
                  v-else
                  >查看</span
                >
              </div>
            </div>
            <div class="typeBoxs" v-if="data.JDInfo && data.JDInfo.length > 0">
              <div class="accessory">
                <span style="margin-left: 14px">相关解读:</span>
              </div>
              <div
                class="titleBox"
                v-for="item in data.JDInfo"
                @click="jumpC(item.id)"
              >
                <span class="title" style="cursor: pointer">{{
                  item.title
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var allThis = ''
import { shanxiDetail, HomeAnalyzeKeyword } from '@/api/api'
export default {
  data() {
    return {
      nav: false,
      type: ['有效', '失效', '部分失效', '-', '时效性'],
      id: this.$route.query.contentId,
      contentId: this.$route.query.cId,
      keyWord: this.$route.query.keyWord,
      data: {},
      loading: '',
      that: this,
      tag: [],
      listId: this.$route.query.listId,
    }
  },
  created() {
    allThis = this
    console.log('asdfssssssssssssssssg')
    this.HomeAnalyzeKeyword()
    setTimeout(() => {
      this.Cmsdetail()
    }, 1000)
  },
  filters: {
    publishDate(v) {
      var date = new Date(v) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      var D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      var h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      var s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D
      //return Y+M+D+h+m+s;
    },
    typeFil(v, that) {
      //that为空 不知道为啥 加个判断 为空时获取别的
      if (that) {
        return that.type[v - 1]
      } else {
        return allThis.type[v - 1]
      }
    },
  },
  methods: {
    vipFun() {
      window.open(
        'http://zsdy-mall-pc.bjzsdy.com/goodsType?appCode=taxlaw',
        '_blank'
      )
    },
    jump(v) {
      let url = process.env.VUE_APP_ZSG_URL + v
      window.open(url, '_blank')
    },
    imgUrl(v) {
      let a = v
      let b = new RegExp('src="/webfile/', 'g')
      if (a) {
        a = a.replace(b, 'src="/webfile/')
      }
      return a
    },
    download(v, k) {
      if (k == 2) {
        if (v.contentFilePath) {
          let src = '/webfile/' + v.contentFilePath
          var $a = document.createElement('a')
          $a.setAttribute('href', src)
          $a.setAttribute('download', v.fileName ? v.fileName : '')
          var evObj = document.createEvent('MouseEvents')
          evObj.initMouseEvent(
            'click',
            true,
            true,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            true,
            false,
            0,
            null
          )
          $a.dispatchEvent(evObj)
        } else {
          this.$message({
            message: '当前附件未上传可下载文件！！！',
            type: 'warning',
          })
        }
      } else {
        let Detail = this.$router.resolve({
          path: '/filesInfo',
          query: { contentId: v.id },
        })
        window.open(Detail.href, '_blank')
      }
    },
    jumpC(v) {
      let Detail = this.$router.resolve({
        path: '/content',
        query: {
          contentId: v,
          keyWord: this.keyWord,
          contentIds: this.contentIds,
        },
      })
      window.open(Detail.href, '_blank')
    },
    HomeAnalyzeKeyword() {
      this.tag = []
      let data = {
        keyword: this.keyWord,
      }
      HomeAnalyzeKeyword(data).then((res) => {
        console.log(res.data.data, 'dddd')
        this.tag = res.data.data
      })
    },
    Cmsdetail() {
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let data = {
        id: this.id + '',
        contentId:this.contentId,
        keyWords: '',
        // keyWords:this.tag.length==0?[this.keyWord.trim()]:this.tag
      }
      if(this.$route.query.tagIds&&this.$route.query.tagIds!=''){
        data.tagIds = [this.$route.query.tagIds];
        delete data.moduleName
      }
      if (this.tag != false) {
        data.keyWords = this.tag
      } else {
        data.keyWords = [this.keyWord.trim()]
      }
      if (this.$route.query.searchType == 3) {
        data.articleNo = this.keyWord.trim()
      }
      shanxiDetail(data).then((res) => {
        console.log(res)
        let text = res.data.data.data[0].content_formatted
        this.data = res.data.data.data[0]
        console.log(this.data)
        if (text.indexOf('id="mhfont"') != -1) {
          this.$forceUpdate()
          this.data.text = text.replace('id="mhfont"', 'id="mhfont1"')
          // setTimeout(() => {
          this.$forceUpdate()
          setTimeout(() => {
            this.$nextTick(() => {
              document.getElementById('mhfont1').scrollIntoView()
            })
          }, 500)

          // }, 2000)
        }
        let that = this
        setTimeout(function () {
          //描蓝 法规跳法规
          that.$nextTick(function () {
            that.addStyle()
          })
        }, 300)

        this.loading.close()
      })
    },
    addStyle() {
      let that = this //debugger
      let changeDiv = document.getElementsByClassName('goto-article')
      if (changeDiv && changeDiv.length != 0) {
        Array.from(changeDiv).forEach((item) => {
          item.style.color = 'blue'
          item.style.cursor = 'pointer'
          item.style.textDecoration = 'underline'
          item.onclick = function () {
            let str = { id: '', keyWord: this.keyWord }
            str.id = item.getAttribute('data-goto-article-id') //获取节点属性
            that.goDetail(str)
          }
        })
      }
    },
    goDetail(item) {
      let routeData = this.$router.resolve({
        path: '/content',
        query: {
          contentId: item.id + '',
          keyWord: this.keyWord,
        },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.midCommon{
  width: 1200px;
  padding: 0 calc(50% - 600px);
  background: #f5f5f5;
  padding-top: 20px;
}
.contentBox {
  width: calc(1200px - 240px);
  // height: calc(1340px - 70px);
  background: #fff;
  margin: 0 auto;
  padding: 35px 120px 35px;
  .title {
    line-height: 36px;
    // width: 790px;
    text-align: center;
    color: #3d3d3d;
    font-size: 18px;
    font-weight: 700;
  }
  .more {
    // height: 92px;
    margin: 20px 0;
    .time {
      color: #888;
      line-height: 24px;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .time:last-child {
      margin-bottom: 0;
    }
  }
  .text {
    padding-top: 16px;
    border-top: 2px solid #d8d8d8;
    font-size: 16px;
    font-weight: normal;
    line-height: 32px;
    letter-spacing: 0em;
    color: #3d3d3d;
    padding-bottom: 40px;
  }
  .typeBoxs {
    .accessory {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-left: 6px solid #003fa8;
      background: #eef8ff;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0em;
      color: #3d3d3d;
      margin-bottom: 15px;
    }
    .titleBox {
      width: calc(100% - 11px);
      padding-left: 11px;
      // height: 30px;
      margin-bottom: 10px;
      .title {
        font-size: 16px;
        font-weight: normal;
        line-height: 30px;
        letter-spacing: 0em;
        color: #0000ff;
      }
      .btn {
        width: 60px;
        height: 30px;
        font-size: 14px;
        font-weight: normal;
        line-height: 30px;
        letter-spacing: 0em;
        color: #fff;
        border-radius: 4px;
        background: #003fa8;
        display: inline-block;
        text-align: center;
        float: right;
      }
    }
  }
}
.vipText {
  margin-top: 25px;
  font-family: SourceHansansCN-Normal;
  font-size: 16px;
  text-align: center;
  color: #e62d2d;
  span {
    color: #2771e2 !important;
    text-decoration: underline;
    cursor: pointer;
  }
}
::v-deep .text table {
  width: 100%;
  border-color: #dfdfdf;
  border-collapse: collapse;
}
::v-deep .text table tr td {
  text-align: center;
  padding: 0.5rem 0;
  border-color: #dfdfdf;
  border: 1px solid #dfdfdf;
}
</style>
